/**
 * Pipeline Labs Lead Finder Filter Options
 *
 * These options match the Pipeline Labs API schema.
 * Extracted from comprehensive schema analysis (500 job titles, 148 industries, etc.)
 */

export const SENIORITY_LEVELS = [
  { value: 'Entry', label: 'Entry' },
  { value: 'Senior', label: 'Senior' },
  { value: 'Manager', label: 'Manager' },
  { value: 'Director', label: 'Director' },
  { value: 'VP', label: 'VP' },
  { value: 'C-Suite', label: 'C-Suite' },
  { value: 'Owner', label: 'Owner' },
  { value: 'Head', label: 'Head' },
  { value: 'Founder', label: 'Founder' },
  { value: 'Partner', label: 'Partner' },
  { value: 'Intern', label: 'Intern' }
];

export const JOB_FUNCTIONS = [
  { value: 'Accounting', label: 'Accounting' },
  { value: 'Administrative', label: 'Administrative' },
  { value: 'Arts & Design', label: 'Arts & Design' },
  { value: 'Business Development', label: 'Business Development' },
  { value: 'Consulting', label: 'Consulting' },
  { value: 'Data Science', label: 'Data Science' },
  { value: 'Education', label: 'Education' },
  { value: 'Engineering', label: 'Engineering' },
  { value: 'Entrepreneurship', label: 'Entrepreneurship' },
  { value: 'Finance', label: 'Finance' },
  { value: 'Human Resources', label: 'Human Resources' },
  { value: 'Information Technology', label: 'Information Technology' },
  { value: 'Legal', label: 'Legal' },
  { value: 'Marketing', label: 'Marketing' },
  { value: 'Media & Communications', label: 'Media & Communications' },
  { value: 'Operations', label: 'Operations' },
  { value: 'Product Management', label: 'Product Management' },
  { value: 'Research', label: 'Research' },
  { value: 'Sales', label: 'Sales' },
  { value: 'Support', label: 'Support' }
];

export const EMPLOYEE_SIZE_RANGES = [
  { value: 'Unknown', label: 'Unknown' },
  { value: '1-10', label: '1-10 employees' },
  { value: '11-20', label: '11-20 employees' },
  { value: '21-50', label: '21-50 employees' },
  { value: '51-100', label: '51-100 employees' },
  { value: '101-200', label: '101-200 employees' },
  { value: '201-500', label: '201-500 employees' },
  { value: '501-1000', label: '501-1,000 employees' },
  { value: '1001-2000', label: '1,001-2,000 employees' },
  { value: '2001-5000', label: '2,001-5,000 employees' },
  { value: '5001-10000', label: '5,001-10,000 employees' },
  { value: '10001+', label: '10,001+ employees' }
];

export const EMAIL_STATUS_OPTIONS = [
  { value: 'verified', label: 'Verified Emails Only' },
  { value: 'unverified', label: 'Unverified Emails Only' }
];

export const COMPANY_NAME_MATCH_MODES = [
  { value: 'phrase', label: 'Phrase Match (Default)' },
  { value: 'exact', label: 'Exact Match' }
];

export const COMPANY_DOMAIN_MATCH_MODES = [
  { value: 'strict', label: 'Strict (Exact Domain)' },
  { value: 'contains', label: 'Contains (Substring)' }
];

// Top 50 most common job titles from Pipeline Labs (500 total available in their system)
// Using AutocompleteInput allows users to search and select from this curated list
export const JOB_TITLES = [
  'Director', 'Manager', 'Founder', 'General Manager', 'Consultant',
  'Chief Executive Officer', 'Co-Founder', 'Account Manager', 'Chief Financial Officer',
  'Human Resources Manager', 'Director Of Marketing', 'Executive Director', 'Executive Assistant',
  'Administrative Assistant', 'Director Of Human Resources', 'Associate', 'Chief Operating Officer',
  'HR Manager', 'Account Executive', 'Business Development Manager', 'Director Of Operations',
  'Controller', 'Chief Technology Officer', 'Chief Information Officer', 'Founder & CEO',
  'Attorney', 'IT Manager', 'Assistant Manager', 'Engineer', 'Business Analyst',
  'Accountant', 'Chief Marketing Officer', 'Creative Director', 'Director Of Sales',
  'Graphic Designer', 'Analyst', 'Human Resources Director', 'Founder And CEO',
  'Director, Information Technology', 'Digital Marketing Manager', 'Business Owner',
  'Assistant Professor', 'Branch Manager', 'HR Director', 'Administrator',
  'Customer Service Representative', 'HR Business Partner', 'Co Founder', 'Designer', 'Intern'
];

// Note: Industries (148 options) are imported from autocompleteData.js
// to share with Peaky Leads implementation
